export enum BroadcastType {
  Ads = 'ADS',
  Info = 'INFO',
}
